export var ImageAnchorTypes;

(function (ImageAnchorTypes) {
  ImageAnchorTypes["N"] = "N";
  ImageAnchorTypes["NE"] = "NE";
  ImageAnchorTypes["E"] = "E";
  ImageAnchorTypes["SE"] = "SE";
  ImageAnchorTypes["S"] = "S";
  ImageAnchorTypes["SW"] = "SW";
  ImageAnchorTypes["W"] = "W";
  ImageAnchorTypes["NW"] = "NW";
  ImageAnchorTypes["C"] = "C";
})(ImageAnchorTypes || (ImageAnchorTypes = {}));

export var ImageSizes;

(function (ImageSizes) {
  ImageSizes["AVATAR"] = "(min-width: 55rem) calc(55rem / 16)";
  ImageSizes["SECTION"] = "(min-width: 75rem) calc(75rem - 2.25rem), calc(100vw - 2.25rem)";
  ImageSizes["ONE_THIRD"] = "(min-width: 75rem) calc((75rem - 6.75rem) * (1/3)), (min-width: 48rem) calc((100vw - 6.75rem) * (1/3)), calc(100vw - 2.25rem)";
  ImageSizes["TWO_THIRDS"] = "(min-width: 75rem) calc((75rem - 3.375rem) * (2/3)), (min-width: 48rem) calc((100vw - 3.375rem) * (2/3)), calc(100vw - 2.25rem)";
  ImageSizes["EDGE_TO_EDGE"] = "100vw";
  ImageSizes["PROFILE"] = "calc(144rem / 16)";
  ImageSizes["section"] = "(min-width: 75rem) calc(75rem - 2.25rem), calc(100vw - 2.25rem)";
  ImageSizes["oneThird"] = "(min-width: 75rem) calc((75rem - 6.75rem) * (1/3)), (min-width: 48rem) calc((100vw - 6.75rem) * (1/3)), calc(100vw - 2.25rem)";
  ImageSizes["twoThirds"] = "(min-width: 75rem) calc((75rem - 3.375rem) * (2/3)), (min-width: 48rem) calc((100vw - 3.375rem) * (2/3)), calc(100vw - 2.25rem)";
  ImageSizes["edgeToEdge"] = "100vw";
})(ImageSizes || (ImageSizes = {}));

export var ImageOverlays;

(function (ImageOverlays) {
  ImageOverlays["SCRIM_BOTTOM_DARK"] = "scrimBottomDark";
})(ImageOverlays || (ImageOverlays = {}));